import script from "./AutorizationHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./AutorizationHeader.vue?vue&type=script&setup=true&lang=js"

import "./AutorizationHeader.vue?vue&type=style&index=0&id=53a943b6&lang=scss"

const __exports__ = script;

export default __exports__